import { TimeStamp } from "./timestamp";

export type Comment = {
  task_comment_id: number;
  task_id: number;
  comment_num: number;
  comment: string;
  user_id: number;
  user_name: string;
  category_id: number;
  category_name: string;
  item_id: number;
  item_name: string;
  process_id: number;
  process_name: string;
  primary_charge_id: number;
  timestamp: TimeStamp;
  roles: number[];
};

// 検索条件設定
export const CommentSearchKey = {
  Category: "category_id",
  Comment: "comment",
  InsertDate: "insert_date",
} as const;

export type CommentSearchKeyType = (typeof CommentSearchKey)[keyof typeof CommentSearchKey];

// 検索条件保存
export type CommentSearchParams = {
  category_id?: number[];
  comment?: string;
  insert_start_date?: string;
  insert_end_date?: string;
};
